import { SHA256nymudvmltc47 as SHA256 } from '../../../../hash-library-sha2/org/kotlincrypto/hash/sha2/SHA256.mjs';
import { hash1raspm89m0xqg as hash } from './Bit32Digest.ext.mjs';
import { Default_getInstance5ktjwh40tq1j as Default_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/io/encoding/Base64.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function hash_0(_this__u8e3s4) {
  var digest = SHA256().j53();
  hash(digest, _this__u8e3s4);
  return Default_getInstance().rq(digest.g51());
}
function hash_1(_this__u8e3s4) {
  var digest = SHA256().j53();
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    hash(digest, item);
  }
  return Default_getInstance().rq(digest.g51());
}
//region block: exports
export {
  hash_0 as hash261sfwzhzsh4z,
  hash_1 as hash3na0rjynj3lfb,
};
//endregion

//# sourceMappingURL=PendingLineItem.ext.mjs.map
